import { useState } from 'react';
import { Buttons, CreatePlacementModal } from 'components';

const CreatePlacementBtn = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Buttons.SecondaryNormal
        id='saveButton'
        style={{ width: '100%' }}
        onClick={() => setShowModal(true)}
      >
        Create Placement
      </Buttons.SecondaryNormal>
      {showModal && <CreatePlacementModal close={() => setShowModal(false)} />}
    </>
  );
};

export default CreatePlacementBtn;
